<footer class="ai-composer" [class.ai-composer-page]="mode === 'page'" [class.ai-composer-popover]="mode === 'popover'">
  <div class="ai-composer-shell" [class.ai-composer-needs-setup]="state.setupRequired()">
    <div class="ai-composer-editor">
      <textarea class="form-control" rows="3" [placeholder]="placeholder" aria-label="Message the AI assistant"
        [value]="message" (input)="updateMessage($any($event.target).value)" (keydown.enter)="onKeydown($event)"></textarea>
    </div>
    <div class="ai-composer-bottombar">
      <div class="ai-composer-left-actions">
        <button class="ai-composer-icon btn btn-icon" type="button" aria-label="Upload files" title="Upload files">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="me-0"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M12 5l0 14" /><path d="M5 12l14 0" /></svg>
        </button>
      </div>
      <div class="ai-composer-right-actions">
        <div class="ai-model-controls" [class.ai-model-controls-empty]="state.availableConnections().length === 0">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="icon icon-tabler icons-tabler-outline icon-tabler-brain ai-model-icon" aria-hidden="true">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M15.5 13a3.5 3.5 0 0 0 -3.5 3.5v1a3.5 3.5 0 0 0 7 0v-1.8" />
            <path d="M8.5 13a3.5 3.5 0 0 1 3.5 3.5v1a3.5 3.5 0 0 1 -7 0v-1.8" />
            <path d="M17.5 16a3.5 3.5 0 0 0 0 -7h-.5" />
            <path d="M19 9.3v-2.8a3.5 3.5 0 0 0 -7 0" />
            <path d="M6.5 16a3.5 3.5 0 0 1 0 -7h.5" />
            <path d="M5 9.3v-2.8a3.5 3.5 0 0 1 7 0v10" />
          </svg>
          <label class="visually-hidden" for="ai-chat-scope">Model scope</label>
          <select id="ai-chat-scope" class="form-select form-select-sm ai-model-scope-picker"
            [value]="state.selectedScope()" (change)="state.selectScope($any($event.target).value)"
            [disabled]="busy">
            <option value="organisation">Organisation</option>
            <option value="personal">Personal</option>
          </select>
          <label class="visually-hidden" for="ai-chat-connection">AI provider connection</label>
          <select id="ai-chat-connection" class="form-select form-select-sm ai-model-picker"
            [value]="state.selectedConnectionId() || ''"
            (change)="state.selectConnection($any($event.target).value)"
            [disabled]="busy || state.scopedConnections().length === 0">
            <option value="" disabled>{{ state.scopedConnections().length ? 'Choose credentials' : 'No connection configured' }}</option>
            <option *ngFor="let connection of state.scopedConnections()" [value]="connection.id">{{ connection.name }} · {{ connection.provider }}</option>
          </select>
          <label class="visually-hidden" for="ai-chat-model">AI model</label>
          <select id="ai-chat-model" class="form-select form-select-sm ai-model-picker"
            [value]="state.selectedModel() || ''"
            (change)="state.selectModel($any($event.target).value)"
            [disabled]="busy || state.loadingModels() || state.availableModels().length === 0">
            <option value="" disabled>{{ state.loadingModels() ? 'Loading models…' : (state.availableModels().length ? 'Choose a model' : 'No models available') }}</option>
            <option *ngFor="let model of state.availableModels()" [value]="model">{{ model }}</option>
          </select>
          <a class="ai-model-settings btn btn-icon" [routerLink]="state.connectionSettingsRoute()"
            aria-label="Open AI model settings" title="AI model settings">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c.996 .608 2.296 .07 2.572 -1.065z" />
              <path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
            </svg>
          </a>
        </div>
        <button class="ai-submit btn" type="button" aria-label="Send message" title="Send message" [disabled]="busy || !message.trim() || !state.selectedModel()" (click)="submit()">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="me-0"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M12 5l0 14" /><path d="M16 9l-4 -4" /><path d="M8 9l4 -4" /></svg>
        </button>
      </div>
    </div>
    <div class="ai-composer-setup-overlay" role="dialog" [attr.aria-labelledby]="'ai-composer-setup-title-' + mode"
      *ngIf="state.setupRequired()">
      <div class="ai-composer-setup-panel">
        <div class="ai-composer-setup-header">
          <div>
            <h3 [id]="'ai-composer-setup-title-' + mode" class="mb-1">Connect an AI model</h3>
            <p class="text-secondary small mb-0">Choose where to configure a model to start chatting.</p>
          </div>
          <button type="button" class="btn-close" aria-label="Close" (click)="state.dismissSetup()"></button>
        </div>
        <div class="ai-composer-setup-options">
          <a class="btn ai-composer-setup-option" routerLink="/configuration/organisation/ai-models"
            (click)="state.dismissSetup()">
            <i class="ti ti-building" aria-hidden="true"></i>
            <span>Organisation models</span>
          </a>
          <a class="btn ai-composer-setup-option" routerLink="/personal/configuration/ai-models"
            (click)="state.dismissSetup()">
            <i class="ti ti-user" aria-hidden="true"></i>
            <span>Personal models</span>
          </a>
        </div>
      </div>
    </div>
  </div>
  <small class="ai-composer-hint" *ngIf="hint">{{ hint }}</small>
</footer>
